<template>
  <v-card>
    <v-card-title>
      <v-btn
        color="success"
        @click="openCooperativeForm('new')"
        :disabled="loading"
        small
        outline
        slot="end"
      >
        <v-icon class="pr-1">receipt_long</v-icon>Adicionar
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="cooperatives"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.cnpj | cnpjMask }}</td>
        <td>{{ props.item.state }}</td>
        <td>{{ props.item.adress }}</td>
        <td>{{ props.item.county }}</td>
        <td>{{ props.item.cep }}</td>
        <td>{{ props.item.district }}</td>
        <td>{{ props.item.trade_board }}</td>

        <td class="text-xs-right">
          <v-tooltip bottom v-if="props.item.terms_url">
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
                :href="props.item.terms_url"
                target="_blank"
              >
                <v-icon left> summarize </v-icon>
              </v-btn>
            </template>
            <span>Estatuto</span>
          </v-tooltip>
          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="openCooperativeForm('edit', props.item)"
            :disabled="loading"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-tooltip bottom v-if="props.item.status !== 'canceled'">
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="error"
                >
                  delete
                </v-icon>
              </v-btn>
            </template>
            <span>Cancelar Cooperativa</span>
          </v-tooltip>

          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="success"
                >
                  restore_from_trash
                </v-icon>
              </v-btn>
            </template>
            <span>Reativar Cooperativa</span>
          </v-tooltip>
        </td>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog_modify_status" max-width="290" dark>
      <v-card color="red">
        <v-card-title class="headline"
          >Tem certeza que deseja
          {{ newStatus !== "canceled" ? "ativar" : "cancelar" }} essa
          cooperativa?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="black darken-1"
            @click="dialog_modify_status = false"
            dark
          >
            Não
          </v-btn>

          <v-btn color="black darken-1" dark @click="cancelOrReactivate()">
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <cooperative-form />
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { eventBus } from "@/main";
import { updateCooperativeFb } from "../../services/cooperatives";
import CooperativeForm from "./CooperativeForm.vue";

export default {
  components: { CooperativeForm },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "ID",
          value: "id",
        },
        {
          text: "CNPJ",
          value: "cnpj",
        },
        {
          text: "Estado",
          value: "state",
        },
        {
          text: "Endereço",
          value: "adress",
        },
        {
          text: "Município",
          value: "county",
        },
        {
          text: "CEP",
          value: "cep",
        },
        {
          text: "Bairro",
          value: "district",
        },
        {
          text: "Junta Comercial",
          value: "trade_board",
        },
      ],
      pag: {
        rowsPerPage: 50,
      },
      dialog_modify_status: false,
      newStatus: null,
      cooperativeId: null,
    };
  },
  computed: {
    ...mapState("configuration", ["loading", "cooperatives"]),
  },
  mounted() {
    if (
      !this.cooperatives ||
      (this.cooperatives && this.cooperatives.length <= 0)
    )
      this.getCooperatives();
  },
  methods: {
    ...mapActions("configuration", ["getCooperatives"]),

    startUpdate(id, status) {
      if (status === "canceled") status = "activated";
      else status = "canceled";

      (this.newStatus = status), (this.cooperativeId = id);
      this.dialog_modify_status = true;
    },

    cancelOrReactivate() {
      if (this.newStatus === "canceled") {
        this.cancelCooperative(this.cooperativeId);
        this.dialog_modify_status = false;
      } else {
        this.reactivateCooperative(this.cooperativeId);
        this.dialog_modify_status = false;
      }
    },

    openCooperativeForm(type, data) {
      let obj = {
        status: true,
        type: type,
        data: data,
      };
      eventBus.$emit("cooperativeForm", obj);
    },

    cancelCooperative(id) {
      let data = {
        updated_at: new Date(),
        status: "canceled",
      };
      updateCooperativeFb(id, data);
    },

    reactivateCooperative(id) {
      let data = {
        updated_at: new Date(),
        status: "activated",
      };
      updateCooperativeFb(id, data);
    },
  },
  filters: {
    cnpjMask(value) {
      if (!value) return "";
      value = value.toString();
      return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        "$1.$2.$3/$4-$5",
      );
    },
  },
};
</script>
